module.exports = __webpack_public_path__ + "static/media/beat_sound_short.0a36874b.mp3";